import React from 'react'

const ArrowRight = () => {
    return (
        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Img">
                <path id="Vector" d="M4.63574 9.80472H15.3636M15.3636 9.80472L9.99967 4.4408M15.3636 9.80472L9.99967 15.1686" stroke="#7703FC" strokeWidth="1.53255" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>
    )
}

export default ArrowRight